export * from './getThemeColor';
